import { render, staticRenderFns } from "./privilegeList.vue?vue&type=template&id=37ebd54c&scoped=true"
import script from "./privilegeList.vue?vue&type=script&lang=js"
export * from "./privilegeList.vue?vue&type=script&lang=js"
import style0 from "./privilegeList.vue?vue&type=style&index=0&id=37ebd54c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ebd54c",
  null
  
)

export default component.exports